module.exports = __webpack_public_path__ + "img/slide4-contenten.4e2f9812.png";